import React from "react";
import { ImCircleRight } from "react-icons/im";
import { useVault } from "../context/VaultContext";

const MyClaimsDetail = ({ item }) => {

  const { setSelectedClaim, selectedClaim } = useVault();
  return (
    <div className={`flex justify-between items-start border-2 rounded-xl p-3 mt-3 ${selectedClaim?.id === item?.id && 'border-primary shadow-md'}`}>
      <div className="w-[55%]">
        <div className="flex justify-between  items-center pb-3">
          <p className="text-sm font-semibold">Claim Name</p>
          <p className="text-xs text-black w-[45%] capitalize">{item?.claimName}</p>
        </div>
        <div className="flex justify-between items-center pb-3">
          <p className="text-sm font-semibold">Claim Number</p>
          <p className="text-xs text-black w-[45%] capitalize ">{item?.claimNumber}</p>
        </div>
        <div className="flex justify-between items-center pb-3">
          <p className="text-sm font-semibold">Claim Type</p>
          <p className="text-xs text-black w-[45%] capitalize">{item?.propertyType}</p>
        </div>
        <div className="flex justify-between items-center">
          <p className="text-sm font-semibold">Claim Date</p>
          <p className="text-xs text-black w-[45%] capitalize">{item?.dateOfClaim}</p>
        </div>
      </div>
      <div className="flex flex-col justify-between items-end">
        <button className="border-2 border-primary bg-primary text-white text-xs rounded-lg py-1 px-2 font-semibold cursor-default mb-12">Active</button>
        <ImCircleRight className="text-2xl text-primary cursor-pointer" onClick={() => setSelectedClaim(item)} />
      </div>
    </div>
  );
};

export default MyClaimsDetail;
